// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from ProductThumbnail.module.scss  */
.ProductThumbnail-module-Root_Psa {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  height: var(--product-thumbnail-height-default);
  border: 1px solid transparent;
  border-radius: 4px; }
  .ProductThumbnail-module-Root_Psa img {
    max-width: 100%;
    max-height: 100%; }

.ProductThumbnail-module-Rating_20r,
.ProductThumbnail-module-Favorite_3Gt,
.ProductThumbnail-module-TopRightComponent_kPM,
.ProductThumbnail-module-BottomRightComponent_1sV {
  position: absolute; }

.ProductThumbnail-module-Favorite_3Gt {
  top: 14px;
  left: 14px; }

.ProductThumbnail-module-Bg_2VF {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit; }

.ProductThumbnail-module-TopRightComponent_kPM {
  top: 12px;
  right: 0; }

.ProductThumbnail-module-BottomRightComponent_1sV {
  right: 2px;
  bottom: 2px; }

.ProductThumbnail-module-Rating_20r {
  bottom: -6px;
  left: -1px;
  padding: 7px 12px 0 0;
  background-color: #fff; }

.ProductThumbnail-module-TopRightComponent_kPM,
.ProductThumbnail-module-BottomRightComponent_1sV,
.ProductThumbnail-module-Rating_20r,
.ProductThumbnail-module-Favorite_3Gt,
.ProductThumbnail-module-Image_2mC {
  z-index: 2; }

.ProductThumbnail-module-Root_Psa.ProductThumbnail-module-flexibleHeight_2zs {
  height: 100%; }

.ProductThumbnail-module-Root_Psa.ProductThumbnail-module-disabled_MYs .ProductThumbnail-module-TopRightComponent_kPM,
.ProductThumbnail-module-Root_Psa.ProductThumbnail-module-disabled_MYs .ProductThumbnail-module-BottomRightComponent_1sV,
.ProductThumbnail-module-Root_Psa.ProductThumbnail-module-disabled_MYs .ProductThumbnail-module-Rating_20r > div,
.ProductThumbnail-module-Root_Psa.ProductThumbnail-module-disabled_MYs .ProductThumbnail-module-Image_2mC,
.ProductThumbnail-module-Root_Psa.ProductThumbnail-module-disabled_MYs .ProductThumbnail-module-Bg_2VF {
  user-select: none;
  pointer-events: none;
  opacity: 0.6; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/ProductThumbnail/ProductThumbnail.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,+CAA+C;EAC/C,6BAA6B;EAC7B,kBAAkB,EAAE;EACpB;IACE,eAAe;IACf,gBAAgB,EAAE;;AAEtB;;;;EAIE,kBAAkB,EAAE;;AAEtB;EACE,SAAS;EACT,UAAU,EAAE;;AAEd;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAE;;AAE1B;EACE,SAAS;EACT,QAAQ,EAAE;;AAEZ;EACE,UAAU;EACV,WAAW,EAAE;;AAEf;EACE,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,sBAAsB,EAAE;;AAE1B;;;;;EAKE,UAAU,EAAE;;AAEd;EACE,YAAY,EAAE;;AAEhB;;;;;EAKE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY,EAAE","sourcesContent":["/*  imported from ProductThumbnail.module.scss  */\n.ProductThumbnail-module-Root_Psa {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  height: var(--product-thumbnail-height-default);\n  border: 1px solid transparent;\n  border-radius: 4px; }\n  .ProductThumbnail-module-Root_Psa img {\n    max-width: 100%;\n    max-height: 100%; }\n\n.ProductThumbnail-module-Rating_20r,\n.ProductThumbnail-module-Favorite_3Gt,\n.ProductThumbnail-module-TopRightComponent_kPM,\n.ProductThumbnail-module-BottomRightComponent_1sV {\n  position: absolute; }\n\n.ProductThumbnail-module-Favorite_3Gt {\n  top: 14px;\n  left: 14px; }\n\n.ProductThumbnail-module-Bg_2VF {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: inherit; }\n\n.ProductThumbnail-module-TopRightComponent_kPM {\n  top: 12px;\n  right: 0; }\n\n.ProductThumbnail-module-BottomRightComponent_1sV {\n  right: 2px;\n  bottom: 2px; }\n\n.ProductThumbnail-module-Rating_20r {\n  bottom: -6px;\n  left: -1px;\n  padding: 7px 12px 0 0;\n  background-color: #fff; }\n\n.ProductThumbnail-module-TopRightComponent_kPM,\n.ProductThumbnail-module-BottomRightComponent_1sV,\n.ProductThumbnail-module-Rating_20r,\n.ProductThumbnail-module-Favorite_3Gt,\n.ProductThumbnail-module-Image_2mC {\n  z-index: 2; }\n\n.ProductThumbnail-module-Root_Psa.ProductThumbnail-module-flexibleHeight_2zs {\n  height: 100%; }\n\n.ProductThumbnail-module-Root_Psa.ProductThumbnail-module-disabled_MYs .ProductThumbnail-module-TopRightComponent_kPM,\n.ProductThumbnail-module-Root_Psa.ProductThumbnail-module-disabled_MYs .ProductThumbnail-module-BottomRightComponent_1sV,\n.ProductThumbnail-module-Root_Psa.ProductThumbnail-module-disabled_MYs .ProductThumbnail-module-Rating_20r > div,\n.ProductThumbnail-module-Root_Psa.ProductThumbnail-module-disabled_MYs .ProductThumbnail-module-Image_2mC,\n.ProductThumbnail-module-Root_Psa.ProductThumbnail-module-disabled_MYs .ProductThumbnail-module-Bg_2VF {\n  user-select: none;\n  pointer-events: none;\n  opacity: 0.6; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
